import React from 'react';
import logo from '../images/LOGO marketBiz-03.png'

function TopMenu({ navigateTopMenu }) {
  const sendClickedMenu = (menuOption) => {
    navigateTopMenu(menuOption); // Envía la opción seleccionada al método recibido por props
  };

  return (
    <header className="header">
      <div className="logo-container">
        <img src={logo} alt="Logo marketBiz" className="logo" />
      </div>
      <nav className="menu-bar">
        <div className="menu-buttons">
          <button className="menu-button" onClick={() => sendClickedMenu('Inicio')}>Inicio</button>
          <button className="menu-button" onClick={() => sendClickedMenu('Caracteristicas')}>Caracteristicas</button>
          <button className="menu-button" onClick={() => sendClickedMenu('Planes y Precios')}>Planes y Precios</button>
          <button className="menu-button" onClick={() => sendClickedMenu('Preguntas Frecuentes')}>Preguntas Frecuentes</button>
          <button className="menu-button" onClick={() => sendClickedMenu('Contacto')}>Contacto</button>
        </div>
      </nav>
      {/* Botón de ingreso */}
      <div className="login-button-container">
        <button className="login-button" onClick={() => window.location.href = 'https://app.marketbiz.ai/'}>INGRESAR A LA APP</button>
      </div>
    </header>
  );
}

export default TopMenu;
